import { Link } from '@tanstack/react-router';
import { IntegrationSettingsDialog } from './integration-settings-dialog';

/**
 * Read-only view of the WhatsApp connection. The business account and its
 * phone number are registered with Meta during WhatsApp signup, and there is
 * no endpoint that changes them from here, so they are shown rather than
 * offered as editable fields.
 */
interface WhatsAppSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDisconnect?: () => void;
  accountName: string | null;
  phoneNumber: string | null;
}

export function WhatsAppSettingsDialog({
  open,
  onOpenChange,
  onDisconnect,
  accountName,
  phoneNumber,
}: WhatsAppSettingsDialogProps) {
  return (
    <IntegrationSettingsDialog
      open={open}
      onOpenChange={onOpenChange}
      title="WhatsApp"
      icon={<img src="/wa-icon.svg" alt="WhatsApp" className="size-10" />}
      onSave={() => onOpenChange(false)}
      saveLabel="Done"
      saveIcon={null}
      onDisconnect={onDisconnect}
    >
      <div className="space-y-1">
        <p className="text-sm font-medium">WhatsApp Business account</p>
        <p className="text-sm text-muted-foreground">
          {accountName ?? 'No account connected'}
        </p>
      </div>

      <div className="space-y-1">
        <p className="text-sm font-medium">Phone number</p>
        <p className="text-sm text-muted-foreground">
          {phoneNumber ?? 'No number connected'}
        </p>
      </div>

      <p className="text-xs text-muted-foreground">
        This is the number registered with Meta for your WhatsApp Business
        account. It can't be changed here.
      </p>

      <p className="text-xs text-muted-foreground">
        Message templates are now managed in{' '}
        <Link
          to="/dashboard/settings/message-templates"
          className="underline underline-offset-2 hover:text-foreground"
        >
          Settings → Message templates
        </Link>
        .
      </p>
    </IntegrationSettingsDialog>
  );
}
